import { TranslateFunction } from "../../../../hooks/useTranslate";

export const mainTableColumnTitles = (t: TranslateFunction): string[] => [
    t('table.columnsTitles.brand'),
    t('table.columnsTitles.model'),
    t('table.columnsTitles.equipmentType'),
    t('table.columnsTitles.substance'),
    t('table.columnsTitles.informationState'),
    t('table.columnsTitles.actions'),
];